<template>
  <div class="courses">
    <h1>Here it will be a page with courses description</h1>
  </div>
</template>
